<template>
  <div class="swiper-block">
    <div :class="swiper_class + ' swiper-container'">
    <!-- <div :class="swiper_class" class="swiper-container"> -->
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <!-- <div class="swiper-slide" v-html="html_code.item2"></div> -->
        <div class="swiper-slide" v-show="hasSlideSlot(item)" v-for="(item) in slideNumber" :key="item">
          <slot :name="'slide' + item"/>
        </div>
        <!-- <div class="swiper-slide" v-if="hasSlideSlot('2')">
          <slot name="slide2"/>
        </div>
        <div class="swiper-slide" v-if="hasSlideSlot('3')">
          <slot name="slide3"/>
        </div>
        <div class="swiper-slide" v-if="hasSlideSlot('4')">
          <slot name="slide4"/>
        </div>
        <div class="swiper-slide" v-if="hasSlideSlot('5')">
          <slot name="slide5"/>
        </div> -->
        <div class="swiper-slide" v-if="hasSlideVideo">
          <slot name="slidevideo"/>
        </div>
        <div class="swiper-slide" v-if="hasSlide3d">
          <slot name="slide3d"/>
        </div>
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>

    </div>
      <!-- If we need navigation buttons -->
      <div :class="swiper_prev_class + ' swiper-button-prev swiper-button posr'" ><i class="icon-arrow-left22 center"></i></div>
      <div :class="swiper_next_class + ' swiper-button-next swiper-button posr'"><i class="icon-arrow-right22 center"></i></div>
  </div>
</template>

<script>
// import "swiper/dist/css/swiper.min.css";
import 'swiper/css/swiper.css'
import Swiper from "swiper/js/swiper.min.js";
export default {
  props: {
    //класс свайпера (обязательно!)
    swiper_class:{
      type: String,
      required: true
    },
    //количество слайдов (обязательно)
    numslider:{
      type: Number,
      required: true
    },
    //количество перелистываемых слайдов
    num_per_group:{
      type: Number,
      default: 1
    },
    //класс стрелки назад (обязательно!)
    swiper_prev_class:{
      type: String,
      required: true
    },
    //класс стрелки вперёд (обязательно!)
    swiper_next_class:{
      type: String,
      required: true
    },
    //отображение количества слайдов
    slides_per_view:{
      type: [Number, String],
      default: 3
    },
    //автоматическая высота
    auto_height:{
      type: Boolean,
      default: true
    },
    //автоматическая прокрутка
    autoplay: {
      type: [Object, Boolean],
      default: false
    },
    //динамическая пагинация
    dynamic_bullets: {
      type: Boolean,
      default: true
    },
    //эффект слайда
    effect_slide: {
      type: String,
      default: "slide"
    },
    //Прокрутка сразу дохрена слайдов
    free_mode: {
      type: Boolean,
      default: false
    },
    //Курсор с захватом
    grab_cursor:{
      type: Boolean,
      default: false
    },
    //Бесконечная прокрутка
    loop: Boolean,
    margin: {
      type: Number,
      default: 20
    }

  },
  data() {
    return {
      slideNumber: this.numslider
    };
  },
  mounted() {

    // setTimeout(function() {
      var mySwiper = new Swiper("."+this.swiper_class, {
        // Optional parameters
        breakpoints: {
          // when window width is <= 640px
          766.9: {
            onlyExternal: false,
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
          },
          1199.9: {
            onlyExternal: false,
            slidesPerView: 3,
            spaceBetween: 20,
            slidesPerGroup: 1,
          }
        },
        freeMode: this.free_mode,
        grabCursor: this.grab_cursor,
        effect: this.effect_slide,
        loop: this.loop,
        slidesPerGroup: this.num_per_group,
        lazy: true,
        // centeredSlides: true,
        slidesPerView: this.slides_per_view,
        autoHeight: this.auto_height,
        spaceBetween: this.margin,
        onlyExternal: true,
        autoplay: this.autoplay,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: this.dynamic_bullets,
          clickable: true,
        },
        navigation: {
          nextEl: '.'+ this.swiper_next_class,
          prevEl: '.'+ this.swiper_prev_class,
        },



        // Navigation arrows
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      });

      var num = this.numslider;

      // console.log(mySwiper.pagination.el);
      // console.log('поле Data: '+this.paginationClass);
      // console.log('это props: '+this.pagination_class);
    // }, 1000);
  },
  methods:{
    hasSlideSlot(val) {
      return this.$slots["slide"+val];
    },
  },
  computed: {

    hasSlide2Slot() {
      return this.$slots["slide2"];
    },
    hasSlide3Slot() {
      return this.$slots["slide3"];
    },
    hasSlide4Slot() {
      return this.$slots["slide4"];
    },
    hasSlide5Slot() {
      return this.$slots["slide5"];
    },
    hasSlideVideo() {
      return this.$slots["slidevideo"];
    },
    hasSlide3d() {
      return this.$slots["slide3d"];
    },
  }
};
</script>

<style lang="scss" scoped>

.swiper-button-next,
.swiper-button-prev,
.swiper-scrollbar {
	display: none;

	outline: none;
}
.swiper-block {
	position: relative;

	max-width: 100%;
	max-height: 100%;
}
.swiper-container {
  padding-bottom: 2.5rem;
  flex: 1;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
	margin: 0 0.75rem !important;
}
.swiper-button {
	width: 2.1875rem;
	height: 2.1875rem;
  z-index: 2;
	background-color: #ffffff;
	background-image: none;
	border-radius: 50%;
	box-shadow: 0 0.375rem 0.75rem -0.125rem rgba(50,50,93,0.25), 0 0.1875rem 0.4375rem -0.1875rem rgba(0,0,0,0.3);

	transition: 0.3s;
	&:hover {
		box-shadow: 0 0.8125rem 1.6875rem -0.3125rem rgba(50,50,93,0.25), 0 0.5rem 1rem -0.5rem rgba(0,0,0,0.3), 0 -0.375rem 1rem -0.375rem rgba(0,0,0,0.025);
		transform: translateY(-0.0625rem);
	}
	&:active {
		box-shadow: 0 0.8125rem 1.6875rem -0.3125rem rgba(50,50,93,0.25), 0 0.5rem 1rem -0.5rem rgba(0,0,0,0.3), 0 -0.375rem 1rem -0.375rem rgba(0,0,0,0.025);
		transform: translateY(0rem);
	}
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
	right: auto;
	left: 0;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
	right: 0;
	left: auto;
}

</style>
